import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=227379ba&scoped=true"
import script from "./Environment.vue?vue&type=script&lang=js"
export * from "./Environment.vue?vue&type=script&lang=js"
import style0 from "./Environment.vue?vue&type=style&index=0&id=227379ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227379ba",
  null
  
)

export default component.exports